export const USER_LOGIN = "user:login";
export const PUSHER_CONNECTED = 'pusher:connected';
export const PUSHER_LOGIN_EVENT = 'pusher:signin_success';
